// Copied from ds/src/app/contexts/sidebar/context.ts
import { createSafeContext } from '@lib/utils/createSafeContext';

export interface SidebarContextValue {
  isExpanded: boolean;
  toggle: () => void;
  open: () => void;
  close: () => void;
}

export const [SidebarContext, useSidebarContext] = createSafeContext<SidebarContextValue>(
  'useSidebarContext must be used within SidebarProvider'
);
